import { computeDealerType } from './compute-dealer-type';
export class MyDealerTracking {
    constructor(
    // use 1_2 because the CMS is not using V2
    myDealerConfigurationService, localeService, mydealerService, logger = console) {
        var _a;
        this.myDealerConfigurationService = myDealerConfigurationService;
        this.localeService = localeService;
        this.mydealerService = mydealerService;
        this.logger = logger;
        this.subscribers = [];
        // on dealer home we get the data synchroniously
        if (this.myDealerConfigurationService.initialPageOwnerConfig) {
            this.currentDealer = this.myDealerConfigurationService.initialPageOwnerConfig;
            this._isOnDealerHome = true;
        }
        else if (this.mydealerService) {
            // anywhere else it is async
            const dealerId = this.mydealerService.getSelectedDealer();
            this.updateDealerInfo(dealerId);
        }
        // register for updates
        (_a = this.mydealerService) === null || _a === void 0 ? void 0 : _a.subscribe(id => {
            this.updateDealerInfo(id);
        });
        this.myDealerConfigurationService.subscribe(id => {
            // whenever the URL changes, the subscribtion fires. If we are not
            // on a dealer home, the id will be undefined.
            this._isOnDealerHome = Boolean(id);
        });
    }
    isOnDealerHome() {
        return this._isOnDealerHome === true;
    }
    /**
     *
     * @returns General user tracking data to be tracked by feature apps and CMS
     */
    getMyDealerTrackingPayloadForUserSection() {
        var _a;
        if (this.currentDealer) {
            const { bnr, name, type } = this.getDealerBaseData(this.currentDealer);
            return {
                user: {
                    dealerInformationBnr: bnr,
                    dealerInformationName: name,
                    dealerInformationType: type,
                    dealerInformationBrand: this.localeService.brand,
                    dealerInformationCountry: this.localeService.market,
                    dealerStatus: true
                }
            };
        }
        return {
            user: {
                dealerStatus: Boolean(this._isOnDealerHome) ||
                    (
                    // this can return undefined to signal that at
                    // this point of time the service has not finished
                    // initialising
                    (_a = this.mydealerService) === null || _a === void 0 ? void 0 : _a.hasDealerState())
            }
        };
    }
    /**
     * Used by CMS. Adds myDealer data to the partner section if and only if
     * we are currently on a dealer home page
     *
     * @returns partner section if on a dealer home, undefined otherwise
     */
    getMyDealerTrackingPayloadForPartnerSection() {
        if (!this.currentDealer || !this._isOnDealerHome) {
            return undefined;
        }
        const { bnr, name, type } = this.getDealerBaseData(this.currentDealer);
        return {
            partner: {
                informationBnr: bnr,
                informationName: name,
                informationType: type,
                informationBrand: this.localeService.brand,
                informationCountry: this.localeService.market
            }
        };
    }
    getCurrentState() {
        return this.currentDealer;
    }
    subscribe(callBack) {
        this.subscribers.push(callBack);
        return () => {
            this.subscribers = this.subscribers.filter(item => item !== callBack);
        };
    }
    getDealerBaseData(dealer) {
        const { id, displayName, legalName } = dealer;
        return {
            bnr: id,
            name: legalName !== null && legalName !== void 0 ? legalName : displayName,
            type: computeDealerType(dealer, this.localeService.marketType)
        };
    }
    updateDealerInfo(dealerId) {
        var _a;
        this.logger.debug('updateDealerInfo - dealer', dealerId, 'current', this.currentDealer);
        if (dealerId) {
            if (((_a = this.currentDealer) === null || _a === void 0 ? void 0 : _a.id) !== dealerId) {
                this.myDealerConfigurationService
                    .getDealer(dealerId)
                    .then(data => {
                    if (data) {
                        this.logger.debug('setting new dealer', data);
                        this.currentDealer = data;
                    }
                    this.subscribers.forEach(cb => cb(data));
                })
                    .catch(e => this.logger.warn(`Could not get data of dealer ${dealerId}`, e));
            }
        }
        else {
            this.currentDealer = undefined;
            this._isOnDealerHome = false; // we get here only if someone invoked mydealerService.setSelectedDealer(undefined).
            this.subscribers.forEach(cb => cb(undefined));
        }
    }
}
